<template>
  <div class="qrcode-preview-wrapper">
    <!--Header-->
    <div class="qrcode-wrapper" :style="{ 'background-color': background }">
      <h4>{{ title }}</h4>
      <div :id="`qrcode-${no}`" :class="[`qrcode-${no}`, 'qrcode']" :ref="`qrcode-${no}`"></div>
      <div class="tips">
        <div class="tip">
          <i class="iconfont icon-qrcode-scan"></i>
          <p>手机扫码</p>
        </div>
        <i class="el-icon-arrow-right" ></i>
        <div class="tip">
          <i class="iconfont icon-qrcode-click"></i>
          <p>点击购买</p>
        </div>
        <i class="el-icon-arrow-right"></i>
        <div class="tip">
          <i class="iconfont icon-qrcode-pay-success"></i>
          <p>购买成功</p>
        </div>
      </div>
    </div>

    <!--Banner-->
    <div class="qrcode-banner">
      <i class="iconfont icon-qrcode-wechat"></i>
      <i class="iconfont icon-qrcode-alipay"></i>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'QrcodePreview',
  props: {
    title: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    background: {
      type: String,
      default: '#25abee'
    }
  },
  data () {
    return {
      qrcode: {},
      no: 0
    }
  },
  watch: {
    url: function (val, oldVal) {
      setTimeout(() => {
        this.showQrcode()
      }, 100)
    }
  },
  methods: {
    // 显示二维码
    showQrcode () {
      if (JSON.stringify(this.qrcode) !== '{}') {
        this.qrcode.clear()
        this.qrcode.makeCode(this.url)
      } else {
        this.qrcode = new QRCode(`qrcode-${this.no}`, {
          width: 200,
          height: 200,
          text: this.url
        })
      }
    }
  },
  mounted () {
    this.no = Math.random() * 1000
    setTimeout(() => {
      this.showQrcode()
    }, 100)
  }
}
</script>

<style lang="scss" scoped>
.qrcode-preview-wrapper {
  width: 260px;
  border-radius: 6px;
  text-align: center;
  box-shadow: 0 3px 10px 0 #ccc;
  overflow: hidden;

  .qrcode-wrapper {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background: #25abee;
    color: #ffffff;

    h4 {
      padding: 1rem 0;
      font-size: 14px;
      margin: 0;
    }

    .qrcode {
      width: 210px;
      height: 210px;
      margin: 0 auto;
      background: #ffffff;
      padding: .4rem;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .tips {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: .4rem;

      .tip {
        text-align: center;
        margin: .4rem;

        i {
          font-size: 24px;
        }
        p {
          margin: .3rem 0;
          font-size: 12px;
        }
      }
    }
  }

  .qrcode-banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .4rem 2rem;

    i {
      font-size: 28px;

      &.icon-qrcode-wechat {
        color: #00b700;
      }
      &.icon-qrcode-alipay {
        color: #25abee;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QrcodePreview.vue